<template>
    <component :is="iconType" v-bind="iconProps" />
</template>
<script>
import Icon from '../icon'
import ProjIcon from './proj-icon'

const defaults = {
    fontClass: "iconfont",
    baseType: "icon",
}

export default {
    name: 'CommonIcon',
    components: { 
        Icon,
        ProjIcon
    },
    props: {
        type: {
            type: String,
            required: true
        },
        color: String,
        size: Number,
        fontClass: {
            type: String,
            default: () => defaults.fontClass
        },
        baseType: {
            type: String,
            default: () => defaults.baseType
        }
    },
    computed: {
        iconType() {
            return this.type.indexOf('_') === 0 ? 'ProjIcon' : 'Icon'
        },
        iconName() {
            return this.iconType === 'ProjIcon' ? this.getCustomIconName(this.type) : this.type
        },
        iconSize() {
            return this.size || (this.iconType === 'ProjIcon' ? 12 : undefined)
        },
        iconColor() {
            return this.color || ''
        },
        iconProps(){
            var props = {
                type: this.iconName,
                color: this.iconColor,
                size: this.iconSize,
            }

            if(this.iconType == "ProjIcon"){
                props.fontClass = this.fontClass
                props.baseType = this.baseType
            }

            return props
        }
    },
    methods: {
        getCustomIconName(iconName) {
            return iconName.slice(1)
        }
    },
    defaults
}

</script>
<style>
</style>
